"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.check = void 0;
exports.check = {
    path: "M7.32917 13.2292L3.85417 9.75417L2.67084 10.9292L7.32917 15.5875L17.3292 5.58751L16.1542 4.41251L7.32917 13.2292Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
